export interface SearchReserveContactMailRequest {
  dateFrom: string
  dateTo: string
  userRegistrationBranchCode: string
  receiveBranchCode: string
  isSendContacted: boolean
  batchType: string
}

export function SearchReserveContactMailRequestToJSON(
  value: SearchReserveContactMailRequest
): any {
  return {
    date_from: value.dateFrom !== '' ? value.dateFrom : undefined,
    date_to: value.dateTo !== '' ? value.dateTo : undefined,
    user_registration_branch_code:
      value.userRegistrationBranchCode !== ''
        ? value.userRegistrationBranchCode
        : undefined,
    receive_branch_code:
      value.receiveBranchCode !== '' ? value.receiveBranchCode : undefined,
    is_send_contacted: value.isSendContacted ?? undefined,
    batch_type: value.batchType
  }
}
